import React, { useLayoutEffect, useReducer } from 'react';
import { Routes, Route, BrowserRouter, Outlet, useLocation } from 'react-router-dom';
// import '@ionic/react/css/core.css';
import { createGlobalStyle } from 'styled-components';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import ScrollToTop from './components/ScrollToTop';
import settingsService from './services/settings.service';
import AnalyticsRouteTracker from './components/AnalyticsRouteTracker';
import AnalyticsNotice from './components/AnalyticsNotice';
import { publicAnalyticsPath } from './lib/analytics';
import { adminPalette } from './lib/adminPalette';

//components
import Navbarr from './components/Navbar/Navbar';
import Footerr from './components/Footer';
import AdminNavbar from './components/AdminNavbar/AdminNavbar.js';
import AdminLayout from './components/layout/AdminLayout';
import ThemeSync from './components/shared/ThemeSync';
import AdminDashboard from './screens/Dashboard/AdminDashboard.jsx';
import AnalyticsDashboard from './screens/Analytics/AnalyticsDashboard.jsx';

//Screens
import SignInScreen from './screens/Auth/SignInScreen.jsx';
import ResetPassword from './screens/Auth/ResetPassword.jsx';
import SignupScreen from './screens/Auth/SignUpScreen.jsx';
import ContactUs from './screens/AboutUs/ContactUs.jsx';
import Shipping from './screens/AboutUs/Shipping.jsx';
import PrivacyPolicy from './screens/AboutUs/PrivacyPolicy.jsx';
import ProfileScreen from './screens/ProfileScreen.jsx';
import ChangePassword from './screens/Auth/ChangePassword.jsx';
import VerifyUser from './screens/Auth/VerifyUser.jsx';
import FaqPage from './screens/FaqPage/FaqPage.jsx';
import NewUser from './screens/Users/NewUser.jsx';
import EditUser from './screens/Users/EditUser.jsx';
import ViewUser from './screens/Users/ViewUser.jsx';
import UserList from './screens/Users/UserList.jsx';
import TicketsList from './screens/Tickets/TicketsList.jsx';
import NewTicket from './screens/Tickets/NewTicket.jsx';
import Rifas from './screens/Rifas/Rifas.jsx';
import NuevaRifa from './screens/Rifas/NuevaRifa.jsx';
import EditRifa from './screens/Rifas/EditRifa.jsx';
import RifaDetails from './screens/Rifas/RifaDetails.jsx';
import RifaTicketDesigner from './screens/Rifas/RifaTicketDesigner.jsx';
import Reservas from './screens/Reservas/ListaReservas.jsx';
import AddReserva from './screens/Reservas/NuevaReserva.jsx';
import ConfirmarReserva from './screens/Reservas/ConfirmarReserva.jsx';
import ConfirmarPago from './screens/Reservas/ConfirmarPago.jsx';
import VerPredio from './screens/Cliente/VerPredio.jsx';
import HomeScreen from './screens/HomeScreens/HomeScreen.jsx';
import TicketsRifa from './screens/Tickets/TicketsRifa.jsx';
import BoardTicketsRifa from './screens/Tickets/BoardTicketsRifa.jsx';
import NuevaReservaCasilla from './screens/Reservas/NuevaReservaCasilla.jsx';
import ListaVendedores from './screens/Vendedores/ListaVendedores.jsx';
import NuevoVendedor from './screens/Vendedores/NuevoVendedor.jsx';
import EditVendedor from './screens/Vendedores/EditVendedor.jsx';
import ViewVendedor from './screens/Vendedores/ViewVendedor.jsx';
import AdminConfigScreen from './screens/AdminConfigScreen/AdminConfigScreen';
import NewsletterList from './screens/Newsletter/NewsletterList.jsx';
import ScanTicket from './screens/Redeem/ScanTicket.jsx';
import SorteoEnVivo from './screens/Sorteos/SorteoEnVivo.jsx';
import {
  LegacyBoardRedirect,
  LegacyBuyTicketsRedirect,
  LegacyCheckoutRedirect,
  LegacyReserveBoardRedirect,
  LegacyReserveRedirect,
} from './components/routing/LegacyRouteRedirect.jsx';

const COLOR_DEFAULTS = {
  $primary: '#086cbf',
  $secondary: '#b51913',
  $background: '#dbdbdb',
  $utils: '#086cbf',
  $navFont: '#f7f7f7',
  $shadowNav: '#086cbf',
  $icons: '#ffffff',
  $titles: '#ffffff',
  $btnFont: '#ffffff',
};

/** Declared once at module scope — props only supply theme values (no createGlobalStyle inside render). */
const GlobalStyles = createGlobalStyle`
  :root {
    --primaryColor: ${p => p.$primary};
    --secondaryColor: ${p => p.$secondary};
    --background-color: ${p => p.$background};
    --utilsColor: ${p => p.$utils};
    --navFontColor: ${p => p.$navFont};
    --shadowNavColor: ${p => p.$shadowNav};
    --IconsColor: ${p => p.$icons};
    --titlesColor: ${p => p.$titles};
    --btnFontColor: ${p => p.$btnFont};
    --primary: ${p => p.$adminPrimary};
    --primary-foreground: ${p => p.$adminPrimaryForeground};
    --secondary: ${p => p.$adminSecondary};
    --secondary-foreground: ${p => p.$adminSecondaryForeground};
    --ring: ${p => p.$adminPrimary};
  }
  html.dark {
    --primary: ${p => p.$adminDarkPrimary};
    --primary-foreground: ${p => p.$adminDarkPrimaryForeground};
    --secondary: ${p => p.$adminDarkSecondary};
    --secondary-foreground: ${p => p.$adminDarkSecondaryForeground};
    --ring: ${p => p.$adminDarkPrimary};
  }
`;

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, GotaSettings: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, {
    GotaSettings: {},
    loading: true,
    error: '',
  });

  useLayoutEffect(() => {
    const fetchData = async () => {
      try {
        dispatch({ type: 'FETCH_REQUEST' });
        const colors = await settingsService.getColors();
        dispatch({ type: 'FETCH_SUCCESS', payload: colors });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: err.message });
      }
    };
    fetchData();
  }, []);

  const g = state.GotaSettings || {};
  const theme = {
    $primary: g.primaryColor || COLOR_DEFAULTS.$primary,
    $secondary: g.secondaryColor || COLOR_DEFAULTS.$secondary,
    $background: g.backgroundColor || COLOR_DEFAULTS.$background,
    $utils: g.utilsColor || COLOR_DEFAULTS.$utils,
    $navFont: g.navFontColor || COLOR_DEFAULTS.$navFont,
    $shadowNav: g.shadowNavColor || COLOR_DEFAULTS.$shadowNav,
    $icons: g.iconsColor || COLOR_DEFAULTS.$icons,
    $titles: g.titlesColor || COLOR_DEFAULTS.$titles,
    $btnFont: g.btnFontColor || COLOR_DEFAULTS.$btnFont,
  };

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <GlobalStyles {...theme} {...adminPalette(theme.$primary, theme.$secondary)} />
      <ThemeSync />
      <AnalyticsRouteTracker />
      <AnalyticsNotice />
      <ToastContainer position='bottom-center' limit={1} />
      <ScrollToTop></ScrollToTop>
      <Routes>
        {/* Public + auth routes — wrapped with the legacy Navbar/Footer shell. */}
        <Route element={<PublicLayout />}>
          {/* Auth */}
          <Route path='/signin' element={<SignInScreen />} />
          <Route path='/signup' element={<SignupScreen />} />
          <Route path='/profile' element={<ProfileScreen />} />
          <Route path='/reset-password' element={<ResetPassword />} />
          <Route path='/change-password/:token' element={<ChangePassword />} />
          <Route path='/verify-user/:token' element={<VerifyUser />} />

          {/* Public */}
          <Route path='/' element={<HomeScreen />} />
          <Route path='/verPredio' element={<VerPredio />} />
          <Route path='/contact' element={<ContactUs />} />
          <Route path='/bases' element={<Shipping />} />
          <Route path='/privacidad' element={<PrivacyPolicy />} />
          <Route path='/faq' element={<FaqPage />} />

          {/* Public purchase flow — short URLs */}
          <Route path='/comprar/:id' element={<TicketsRifa />} />
          <Route path='/tablero/:id' element={<BoardTicketsRifa />} />
          <Route path='/reserva' element={<AddReserva />} />
          <Route path='/reserva-tablero' element={<NuevaReservaCasilla />} />
          <Route path='/pago/:id' element={<ConfirmarReserva />} />

          {/* Legacy purchase URLs → redirect (keep old bookmarks working) */}
          <Route path='/ticketsRifa/:id' element={<LegacyBuyTicketsRedirect />} />
          <Route path='/boardRifa/:id' element={<LegacyBoardRedirect />} />
          <Route path='/reservarTickets' element={<LegacyReserveRedirect />} />
          <Route path='/reservarCasillas' element={<LegacyReserveBoardRedirect />} />
          <Route path='/confirmarReserva/:id' element={<LegacyCheckoutRedirect />} />
        </Route>

        {/* Admin — clean /admin/* paths */}
        <Route path='/admin' element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path='dashboard' element={<AdminDashboard />} />
          <Route path='analytics' element={<AnalyticsDashboard />} />
          <Route path='rifas' element={<Rifas />} />
          <Route path='rifas/nueva' element={<NuevaRifa />} />
          <Route path='rifas/:id/editar' element={<EditRifa />} />
          <Route path='rifas/:id/boleto' element={<RifaTicketDesigner />} />
          <Route path='rifas/:id' element={<RifaDetails />} />
          <Route path='reservas' element={<Reservas />} />
          <Route path='reservas/:id/confirmar' element={<ConfirmarPago />} />
          <Route path='tickets' element={<TicketsList />} />
          <Route path='tickets/nuevo' element={<NewTicket />} />
          <Route path='vendedores' element={<ListaVendedores />} />
          <Route path='vendedores/nuevo' element={<NuevoVendedor />} />
          <Route path='vendedores/:id' element={<ViewVendedor />} />
          <Route path='vendedores/:id/editar' element={<EditVendedor />} />
          <Route path='usuarios' element={<UserList />} />
          <Route path='usuarios/nuevo' element={<NewUser />} />
          <Route path='usuarios/:id/editar' element={<EditUser />} />
          <Route path='usuarios/:id' element={<ViewUser />} />
          <Route path='newsletter' element={<NewsletterList />} />
          <Route path='validar' element={<ScanTicket />} />
          <Route path='configuracion' element={<AdminConfigScreen />} />
          <Route path='sorteo-en-vivo' element={<SorteoEnVivo />} />
        </Route>

        {/* Admin — legacy /AdminScreen/* (still works) */}
        <Route path='/AdminScreen' element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path='dashboard' element={<AdminDashboard />} />
          <Route path='analytics' element={<AnalyticsDashboard />} />
          <Route path='rifas' element={<Rifas />} />
          <Route path='addRifa' element={<NuevaRifa />} />
          <Route path='editRifa/:id' element={<EditRifa />} />
          <Route path='rifa/:id' element={<RifaDetails />} />
          <Route path='reservas' element={<Reservas />} />
          <Route path='confirmarPago/:id' element={<ConfirmarPago />} />
          <Route path='tickets' element={<TicketsList />} />
          <Route path='newTicket' element={<NewTicket />} />
          <Route path='vendedores' element={<ListaVendedores />} />
          <Route path='nuevoVendedor' element={<NuevoVendedor />} />
          <Route path='vendedor/:id' element={<ViewVendedor />} />
          <Route path='editVendedores/:id' element={<EditVendedor />} />
          <Route path='users' element={<UserList />} />
          <Route path='newUser' element={<NewUser />} />
          <Route path='user/:id' element={<EditUser />} />
          <Route path='editUser/:id' element={<EditUser />} />
          <Route path='admin/:id' element={<ViewUser />} />
          <Route path='newsletter' element={<NewsletterList />} />
          <Route path='redeem' element={<ScanTicket />} />
          <Route path='Config' element={<AdminConfigScreen />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

/**
 * Legacy public/client layout — keeps the old global Navbar/AdminNavbar/Footer
 * shell intact for non-admin routes. As we redesign each client screen we'll
 * peel pieces off this layout (e.g. eventually replace Navbarr with a Figma-
 * styled mobile nav bar).
 */
function PublicLayout() {
  const { pathname } = useLocation();
  return (
    <div className='d-flex flex-column site-container'>
      <Navbarr />
      <AdminNavbar />
      <main data-clarity-mask={publicAnalyticsPath(pathname) ? undefined : 'true'}>
        <Outlet />
      </main>
      <Footerr />
    </div>
  );
}

export default App;
